import { memo } from "react"
import cn from "clsx"
import styles from "./styles.module.scss"
import SbEditable from "storyblok-react"
import { imageService } from "utils"
import type { HTMLAttributes } from "react"
import type { SbEditableContent } from "storyblok-react"
import type { Feedback } from "storyblok/schema"

import fallbackPhoto from "./assets/photo-fallback.svg"
import { Icon } from "components/Page/Footer/assets/linkedin"


interface ItemProps
extends HTMLAttributes<HTMLLIElement>, SbEditableContent, Feedback {
  active: boolean
}

export const Item = memo<ItemProps>(({
  company, text, position, person, link, photo,
  component, _uid, _editable,
  active, className, ...rest
}) => (
  <SbEditable content={{ component, _uid, _editable }}>
    <li {...rest} className={cn(styles.item, className, {[styles.active]: active})}>
      <picture className={styles.photo}>
        <source type="image/webp" src={photo.filename && imageService(photo.filename, {
          filter: { format: 'webp' },
          resize: { width: 200 },
        })} />
        <a className={styles.link} 
          href={link} 
          target="_blank" 
          rel="noreferrer"
          title="Visit Linkedin profile">
          <img alt="Profile photo" decoding="async"
            src={photo.filename ? imageService(photo.filename, {
            filter: { format: 'jpeg' },
            resize: { width: 200 },
          }) : fallbackPhoto.src} />
          <div className={styles.iconHolder}>
            <Icon />
          </div>
        </a>
      </picture>
      <div className={styles.content}>
        <h3 className={styles.name}>{person}</h3>
        <p className={styles.title}>{position} @ {company}</p>
        <q className={styles.quote}>{text}</q>
      </div>
    </li>
  </SbEditable>
))

Item.displayName = 'FeedbackItem'
